/**
 * Normalizes a string by removing diacritics/accents
 * for accent-insensitive comparison
 */
export function normalizeString(str: string): string {
  return str
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase();
}
